














































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import AppMessage from 'modules/core/models/appMessage';
import { ProfileModel } from '../classes/profile';
import { PasswdChangeModel } from '../classes/passwdChange';
import { ProfileApi } from '../api/profile';
import LanguagePicker from './LanguagePicker.vue';
import PhonePrefix from '../../core/components/forms/PhonePrefix.vue';
import { Languages } from '../../core/enums/languages';
import { Action } from 'vuex-class';

@Component({
  components: {
    LanguagePicker,
    PhonePrefix,
  },
})
export default class Profile extends Vue {
  public loading: boolean = false;
  public loadingProfileForm: boolean = false;
  public loadingPasswdChangeForm: boolean = false;
  public profileFormRules!: any;
  public profileForm: ProfileModel;
  public profileApi: ProfileApi;
  public passwdChangeFormRules!: any;
  public passwdChangeForm: PasswdChangeModel;

  @Action('auth/setUserLanguage') private setUserLanguage!: (
    token: string,
  ) => void;

  constructor() {
    super();
    this.profileApi = new ProfileApi();
    this.profileForm = new ProfileModel();
    this.passwdChangeForm = new PasswdChangeModel();
  }

  public async created() {
    this.profileFormRules = {
      name: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      accountName: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
    };

    this.passwdChangeFormRules = {
      currentPassword: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
      ],
      newPassword: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
            if (strongRegex.test(value)) {
              callback();
            } else {
              callback(new Error(this.$t('forms.passwordPolicy') as string));
            }
          },
        },
      ],
      newPasswordRepeat: [
        { required: true, message: this.$t('forms.required'), trigger: 'blur' },
        {
          trigger: 'blur',
          validator: (rule: any, value: string, callback: (error?: Error) => void) => {
            if (value !== '' && value === this.passwdChangeForm.newPassword) {
              callback();
            } else {
              callback(new Error(this.$t('forms.passwordsNotMatch') as string));
            }
          },
        },
      ],
    };

    try {
      this.profileForm = await this.profileApi.getProfile();
    } catch (error) {
      console.log(error);
    }
  }

  public languageUpdated(lang: Languages) {
    this.profileForm.language = lang;
  }

  public defaultPhoneNumberPrefixUpdated(prefix: string) {
    this.profileForm.defaultPhoneNumberPrefix = prefix;
  }

  public submitProfileForm() {
    this.loadingProfileForm = true;
    (this.$refs.profileForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.profileApi.updateProfile(this.profileForm).then((data: any) => {
          AppMessage.show(this.$t('profile.profileUpdateSuccess'));
          if (this.$i18n.locale !== this.profileForm.language) {
            this.$i18n.locale = this.profileForm.language;
            this.setUserLanguage(this.profileForm.language);
          }
        }).catch((error: Error) => {
          AppMessage.show(this.$t('forms.error', { msg: error }), 'error');
        }).finally(() => {
          this.loadingProfileForm = false;
        });
      } else {
        this.loadingProfileForm = false;
        return false;
      }
    });
  }

  public submitPasswdChangeForm() {
    this.loadingPasswdChangeForm = true;
    (this.$refs.passwdChangeForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.profileApi.updatePassword(this.passwdChangeForm).then((data: any) => {
          AppMessage.show(this.$t('profile.passwordChangeSuccess'));
          this.passwdChangeForm = new PasswdChangeModel();
        }).catch((error: Error) => {
          // AppMessage.show(this.$t('forms.error', { msg: error }), 'error');
        }).finally(() => {
          this.loadingPasswdChangeForm = false;
        });
      } else {
        this.loadingPasswdChangeForm = false;
        return false;
      }
    });
  }
}
